import {Navbar,Footer} from '../components';
import {useParams} from 'react-router-dom';
import {useState,useEffect} from 'react';
import axios from "axios";
import configData from "../config.json";
import { useNavigate, Link } from "react-router-dom";
import * as Icon from 'react-bootstrap-icons';
import { monthList } from '../utils/datalist';
import { Modal, Button, Form, Tabs, Tab } from "react-bootstrap";
import { LineChart,BarChart,Bar,AreaChart,Area, Rectangle, Line, XAxis, YAxis, 
  CartesianGrid, Tooltip, Legend, ResponsiveContainer,Label,LabelList,Cell,ReferenceLine } from "recharts";

function TargetEntry(){

    if(localStorage.getItem('branchID')===null){
      window.location.replace('/');
    }

    const [misData,setMisData]=useState([]);
    const [yearTarget,setYearTarget]=useState([]);
    const [fYear,setfYear]=useState(2025);

    const [inputData,setInputData]=useState([]);    
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [isEditing, setIsEditing] = useState(false);
    const [dataFound,setDataFound]=useState(true);

    const handleCloseYearly = () => setShow(false);
    const handleShowYearly = () => setShow(true);
    const [isEditingYearly, setIsEditingYearly] = useState(false);

    useEffect(() => {
        Number(localStorage.getItem('branchID'))===10 ? setDataFound(false) : setDataFound(true);

        const date = new Date();
        let currentYear = date.getFullYear();
        if (date.getMonth() + 1 <= 6) {
        currentYear = currentYear - 1;
        }
        setfYear(currentYear);
  
    }, []);


    const getMisDataByYear=async(e)=>{
        if (!fYear) {
            console.log("fYear is empty");
            return;
        }
        const response=await axios.get(configData.SERVER_URL+`/targetEntry/${localStorage.getItem('branchID')}/${fYear}`)
        setMisData(response.data.monthTarget);
        setYearTarget(response.data.yearTarget);
        setIsEditingYearly(false);
    }

    const handleInputDataYearly = (e) => {
        const { name, value } = e.target;

        setYearTarget(prev => [
            { ...prev[0], [name]: value }
        ]);
    };

    const handleInputData=(e)=>{
        const {name,value}=e.target; 
        const newData = {...inputData,[name]: value}; 
    
        newData.branchID = localStorage.getItem('branchID'); 
        newData.fYear=fYear;
        setInputData(newData); 
    }

    const handleSubmitInsert =async(e) => {
        e.preventDefault(); 

        try {
            let res=await axios.post(configData.SERVER_URL+`/targetInsert`,inputData);
            if(res.status===200){
                alert(res.data.message);
                getMisDataByYear();
            } 
            } catch (error) {
            console.error('System error:', error);
        } 
        handleClose();
    };

    const handleSubmitEdit =async(e) => {
        e.preventDefault(); 

        try {
            let res=await axios.post(configData.SERVER_URL+`/targetEdit`,inputData);
            if(res.status===200){
                alert(res.data.message);
                getMisDataByYear();
            } 
            } catch (error) {
            console.error('System error:', error);
        } 
        handleClose();
    };

    const addTarget=()=>{
        setIsEditing(false);
        handleShow();
    }

    const editTarget=(data)=>{
        setIsEditing(true);
        setInputData(data);
        handleShow();
    }

    const editYearTarget=(data)=>{
        setIsEditingYearly(true);
    }

    const updateYearTarget=()=>{
        handleSubmitEditYearly();
        setIsEditingYearly(false);
    };

    const handleSubmitEditYearly =async() => {
        try {
            let res=await axios.post(configData.SERVER_URL+`/targetEditYear`,yearTarget);
            console.log(res);
            if(res.status===200){
                alert(res.data.message);
                getMisDataByYear();
            } 
            } catch (error) {
            console.error('System error:', error);
        } 
    };


    return (
    <>
    {dataFound ? (
      <div className='container'>

      <Modal show={show} onHide={handleClose} style={{marginTop:50}}>
        <Modal.Header closeButton>
            <Modal.Title>{isEditing ? 'Edit' : 'Insert'} Target Entry</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form onSubmit={isEditing ? handleSubmitEdit : handleSubmitInsert}>
                <Form.Group className="mb-3">
                    <Form.Label>Month</Form.Label>
                    <Form.Select  id="aMonth" name="aMonth" onChange={(e)=>{handleInputData(e)}}  value={inputData.aMonth} required>
                        {monthList.map(month => (
                        <option key={month.id} value={month.id}>{month.name}</option>
                        ))}   
                    </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Production Target</Form.Label>
                    <Form.Control type='number' id='proMtQty' name='proMtQty' onChange={(e)=>{handleInputData(e)}} value={inputData.proMtQty} required/>
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Production Value</Form.Label>
                    <Form.Control type='number' id='proMtValue' name='proMtValue' onChange={(e)=>{handleInputData(e)}} value={inputData.proMtValue} required/>
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Adjustment (Pro. Qty)</Form.Label>
                    <Form.Control type='number' id='proAdjustQty' name='proAdjustQty' onChange={(e)=>{handleInputData(e)}} value={inputData.proAdjustQty} defaultValue={0}/>
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Sales Target</Form.Label>
                    <Form.Control type='number' id='mtQty' name='mtQty' onChange={(e)=>{handleInputData(e)}} value={inputData.mtQty} required/>
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Sales Value</Form.Label>
                    <Form.Control type='number' id='mtValue' name='mtValue' onChange={(e)=>{handleInputData(e)}} value={inputData.mtValue} required/>
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Adjustment (Sales Qty)</Form.Label>
                    <Form.Control type='number' id='salesAdjustQty' name='salesAdjustQty' onChange={(e)=>{handleInputData(e)}} value={inputData.salesAdjustQty} defaultValue={0}/>
                </Form.Group>
                
                <Form.Group className="mb-3">
                    <Button variant="success" type="submit" id="btnTargetEntry">Submit</Button>
                </Form.Group>
            </Form>

        </Modal.Body>
        <Modal.Footer closeButton></Modal.Footer>

      </Modal>

        <div className='well' >

            <div className="card my-3 bg-info">
                <h5 className='card-title'>Target Details</h5>
                <div className="card-body">
                    <div className='row'>
                            <div className='col-lg-4 col-md-6 col-sm-6 col-xs-6'> 
                                <div class="input-group">
                                    <input type="number" class="form-control rounded" id='search' name='search' placeholder="Year" 
                                    value={fYear} onChange={(e)=>{setfYear(e.target.value)}} />
                                    <button type="button" class="btn btn-outline-primary" onClick={getMisDataByYear}>search</button>
                                </div>
                            </div>
                    </div>
                </div>
            </div>

            <div className="card my-3">
                <div className='card-header'>
                    <div className='col-lg-4 col-md-6 col-sm-6 col-xs-6'>
                        <div class="input-group">
                        <h5 className='card-title'>Yearly Target (Tk In Lac)</h5>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row table-responsive">
                    <table class="table table-success table-hover table-bordered" style={{fontSize:'small'}}> 
                        <thead className='table-info'>
                        <tr align="center">
                            <th>Year</th>    
                            <th>Production Qty</th>
                            <th>Production Value</th>                        
                            <th>Target Qty</th>
                            <th>Target Value</th>                                                       
                            <th>Unit</th>
                            <th>Profit</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                        yearTarget && yearTarget.length>0 && yearTarget.map((data)=> 
                        <tr align="right">
                            <td align="left">{data.fYear}</td>
                             <td>
                                <input type="number" className="form-control" name="proTargetQty" id="proTargetQty"
                                    value={data.proTargetQty || ''}
                                    onChange={handleInputDataYearly}
                                    disabled={!isEditingYearly}
                                />
                            </td>

                            <td>
                                <input type="number" className="form-control" name="proTargetValue" id="proTargetValue"
                                    value={data.proTargetValue || ''}
                                    onChange={handleInputDataYearly}
                                    disabled={!isEditingYearly}
                                />
                            </td>

                            <td>
                                <input type="number" className="form-control" name="targetQty" id="targetQty"
                                    value={data.targetQty || ''}
                                    onChange={handleInputDataYearly}
                                    disabled={!isEditingYearly}
                                />
                            </td>

                            <td>
                                <input type="number" className="form-control" name="targetValue" id="targetValue"
                                    value={data.targetValue || ''}
                                    onChange={handleInputDataYearly}
                                    disabled={!isEditingYearly}
                                />
                            </td>

                            <td>
                                <input type="text" className="form-control" name="units" id="units"
                                    value={data.units || ''}
                                    onChange={handleInputDataYearly}
                                    disabled={!isEditingYearly}
                                />
                            </td>

                            <td>
                                <input type="number" className="form-control" name="profitTarget" id="profitTarget"
                                    value={data.profitTarget || ''}
                                    onChange={handleInputDataYearly}
                                    disabled={!isEditingYearly}
                                />
                            </td>                           
                            <td>
                                {!isEditingYearly ? (
                                <button className='btn btn-info btn-sm' 
                                    onClick={()=>editYearTarget(data)} style={{marginRight:10}}>
                                    <Icon.Pencil size={20}/>
                                </button>
                                ) : ( ''
                                )}

                                {isEditingYearly ? (
                                    <button  className="btn btn-info btn-sm" 
                                    onClick={() => updateYearTarget(data)} >
                                    <Icon.BookmarkCheck size={20} />
                                </button>
                                ) : ( ''
                                )}
                            </td>
                        </tr>
                        )}
                        </tbody>
                    </table>                 
                    </div>
                </div>
            </div>

            <div className="card my-3">
                
                <div className='card-header'>
                    <div className='col-lg-4 col-md-6 col-sm-6 col-xs-6'>
                        <div class="input-group">
                        <h5 className='card-title'>Monthly Target (Tk In Lac)</h5>
                        <button type="button" class="btn btn-info"  onClick={() => {addTarget()}} style={{marginLeft:'10px'}}>
                            <span><Icon.PlusCircle size={24}/></span>              
                        </button>
                        </div>
                    </div>
                </div>
                
                <div className="card-body">
                    <div className="row table-responsive">
                    <table class="table table-success table-hover table-bordered" style={{fontSize:'small'}}> 
                        <thead className='table-info'>
                        <tr align="center">
                            <th>Month</th>   
                            <th>Pro.Target Qty</th>
                            <th>Adjust Pro. Qty</th> 
                            <th>Updated Pro. Target</th>
                            <th>Pro. Target Value</th>  
                                                  
                            <th>Sales Target Qty</th>
                            <th>Adjust Sales Qty</th>
                            <th>Updated Sales Target</th>
                            <th>Sales Target Value</th> 
                                                         
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                        misData && misData.length>0 && misData.map((data)=> 
                        <tr align="right">
                            <td align="left">{data.monthName}</td>
                            <td>{data.proMtQty}</td>
                            <td style={{backgroundColor:'pink'}}>{data.proAdjustQty}</td>
                            <td>{data.updatedProMtQty}</td>
                            <td>{Number(data.updatedProMtValue).toFixed(2).toLocaleString('en-IN')}</td>
                            
                            <td>{data.mtQty}</td>
                            <td style={{backgroundColor:'pink'}}>{data.salesAdjustQty}</td>    
                            <td>{data.updatedMtQty}</td>
                            <td>{Number(data.updatedMtValue).toFixed(2).toLocaleString('en-IN')}</td>   
                                                
                            <td>
                                <button className='btn btn-info btn-sm' onClick={()=>editTarget(data)}><Icon.Pencil size={20}/></button>
                            </td>
                        </tr>
                        )}
                        </tbody>
                    </table>                 
                    </div>
                </div>
                
                {/* {misData && misData.length>0 ?
                <div className="card-footer">
                    <div className="card text-white bg-info o-hidden h-100">
                        <h4 class="text-center mb-4">Monthly Target Graph</h4>                                           
                        <div className="card-body" style={{ backgroundColor: "lavenderblush", padding: "20px", borderRadius: "10px" }}>
                            <ResponsiveContainer width="100%" height={300} margin={{ top: 5, right: 30, left: 30, bottom: 5 }}>
                                <LineChart data={misData}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="monthName" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Line type="monotone" dataKey="proMtQty" stroke="blue" name="Pro. Target" label={{ position: "insideRight" }} ></Line>
                                    <Line type="monotone" dataKey="mtQty" stroke="green" name="Sales Target" label={{ position: "insideRight" }} ></Line>                                         
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
                :<div></div>
                } */}
                
            </div>
        </div>

      </div>
    ):(
        <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
        <h5>Not Authorized</h5>
        </div>
    )}
    </>
    )
}

export default TargetEntry;